module.exports = __webpack_public_path__ + "img/bg-balance.cd464bd5.png";